import { useEffect } from 'react';
import { datadogRum } from 'common-datadog';

const useSetRUMUser = ({ me, prequal }) => {
  useEffect(() => {
    if (prequal) {
      datadogRum.setUser({
        id: prequal.capsId,
        name: `${prequal.firstName} ${prequal.lastName}`,
        email: prequal.email,
        phone: prequal.phone,
      });
    } else if (me) {
      datadogRum.setUser({ id: me.userId });
    }
  }, [me, prequal]);
};

export default useSetRUMUser;
